import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link2 } from "lucide-react";
import { TextField } from "@/shared/ui/core";
import { FormSection, Thumb } from "@/features/admin/components";
import type { PackageFormValues } from "../packageForm";

/**
 * La imagen del paquete, POR DIRECCIÓN.
 *
 * Todavía no hay subida de archivos, y fingir que la hay con un botón
 * que no funciona es peor que no tenerla. Se pega la dirección de una
 * imagen que ya está publicada en algún sitio.
 *
 * ── Ojo: aquí la ruta del propio sitio NO vale ───────────────────────
 * El formulario del producto acepta las dos formas —`https://…` y
 * `/assets/…`— porque su contrato lo dice así. El del paquete NO:
 * `packageInputSchema` usa `z.url()` a secas, que exige un origen y
 * rechaza `/assets/paquete.webp` con un "dirección no válida" que no
 * explica nada. El texto de ayuda lo dice antes de que alguien lo
 * descubra escribiendo — y queda anotado para quien mantenga el
 * contrato: la diferencia entre las dos entidades parece un descuido,
 * no una decisión.
 *
 * La vista previa no es adorno: una URL escrita a mano se equivoca a
 * menudo, y sin previa el error se descubre en la tienda. Si la imagen
 * no carga, `Thumb` cae al hueco con icono — que es justo la señal de
 * "esta dirección no sirve".
 */
export function PackageImageField() {
  const { t } = useTranslation();
  const { control } = useFormContext<PackageFormValues>();
  const imageUrl = useWatch({ control, name: "imageUrl" });

  return (
    <FormSection
      title={t("Imagen")}
      description={t("Pega una dirección completa (https://…) de una imagen ya publicada.")}
      columns={1}
    >
      <div className="flex items-start gap-4">
        <Thumb
          url={imageUrl?.trim() ? imageUrl : undefined}
          name={t("Vista previa")}
          size="lg"
        />
        <TextField
          name="imageUrl"
          label={t("Dirección de la imagen")}
          icon={<Link2 />}
          inputMode="url"
          autoComplete="off"
          placeholder="https://…"
          fieldClassName="flex-1"
        />
      </div>
    </FormSection>
  );
}
